var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".left-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0.997158C0 0.446301 0.537036 -0.000244141 1.19952 -0.000244141H6.79729C7.45978 -0.000244141 7.99681 0.446301 7.99681 0.997158V5.31924H1.19952C0.537036 5.31924 0 4.87269 0 4.32183V0.997158ZM7.99681 5.31924H14.7941C15.4566 5.31924 15.9936 5.76578 15.9936 6.31664V9.64131C15.9936 10.1922 15.4566 10.6387 14.7941 10.6387H7.99681V5.31924ZM0 11.6361C0 11.0853 0.537036 10.6387 1.19952 10.6387H7.99681V14.9608C7.99681 15.5117 7.45978 15.9582 6.79729 15.9582H1.19952C0.537036 15.9582 0 15.5117 0 14.9608V11.6361Z",
    fill: "#F26207"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplit);
export default __webpack_public_path__ + "static/media/Replit.be6da0b57ee0bbc8bdb630639ca9d87a.svg";
export { ForwardRef as ReactComponent };